import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Grid, Button, Checkbox, withStyles  } from '@material-ui/core';
import * as downloadConfigReducers from '../reducer/DownloadConfigSelectReducers';
import * as downloadConfigActionMgr from '../action-mgr/DownloadConfigSelectActionMgr';
import * as strings from '../../helpers/strings';
import '../../index.css';

const styles = {
  DownloadList: {
    height: 280,
    overflow: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(0, 0, 0, 0.3) transparent',
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },
  DownloadListSmall: {
    height: 80,
  },
  DownloadListLarge: {
    height: 360,
  }
};

class RequestConfigTable extends Component {
  constructor() {
    super();
    this.state = {
      allChecked: false,
      downloadButtonDisabled: true,
      checkedItems: {},
      downloadConfigList: [],
      selectedFiles: [],

    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checkedItems !== this.props.checkedItems) {
      this.setState({ checkedItems: this.props.checkedItems });
    }
  }

  extractFileName = (filePath) => {
    const pathParts = filePath.split('/');
    return pathParts[pathParts.length - 1];
  };

  handleFileCheckboxChange = (downloadList) => {
    const checkedItems = { ...this.state.checkedItems };
    checkedItems[downloadList] = !checkedItems[downloadList];
  
    // Check if at least one individual checkbox is checked
    const atLeastOneChecked = Object.values(checkedItems).some((isChecked) => isChecked);
  
    this.setState({
      checkedItems,
      downloadButtonDisabled: !atLeastOneChecked, // Enable the download button if at least one is checked
    });
  };

  handleDownload = () => {
    const { generateDownloadConfigLink } = this.props;
    const checkedItems = this.state.checkedItems;
  
    // Get the list of selected files
    const selectedFiles = Object.keys(checkedItems).filter((file) => checkedItems[file] && file.endsWith('.pdf'));
  
    generateDownloadConfigLink({ fileList: selectedFiles });
  } 

  render() {

  const { classes, downloadConfigObject } = this.props;
  
  if (!downloadConfigObject || !downloadConfigObject.downloadConfigList) {
    return <div>Please submit your request to generate the report download link.</div>;
  }

  const fileNameList = downloadConfigObject.downloadConfigList.fileName;
  
  const dynamicHeightClass = fileNameList.length === 1 ? classes.DownloadListSmall : classes.DownloadListLarge;

  // Check if at least one checkbox is checked
  const atLeastOneChecked = Object.values(this.state.checkedItems).some((isChecked) => isChecked);

  return (
    <Paper className="downloadReportResult">
      <ul className="downloadReportList">
        <li className="downloadReportHeader">
          <span className="downloadReportHeaderSpan">
            Select
          </span>
          <span>{strings.lblName}</span>
        </li>
      </ul>
      <div className={`${classes.DownloadList} ${dynamicHeightClass}`}>
        <ul className="downloadConfigListItem">
          {fileNameList.map((link, index) => (
            <li key={index}>
              <span>
                <Checkbox
                  color={strings.colorPrimary}
                  checked={this.state.checkedItems[link] || false}
                  onChange={() => this.handleFileCheckboxChange(link)}
                />
              </span>
              <span>{this.extractFileName(link)}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className='downloadReportDownload'>
          <Button 
            variant={strings.btnRaised}
            color={strings.colorPrimary}
            onClick={this.handleDownload}
            disabled={!atLeastOneChecked}
          >
            {strings.lblDownload}
          </Button>          
      </div>
    </Paper>
  );
  }
}

const mapStateToProps = (state) => ({
  downloadConfigObject: downloadConfigReducers.listDownloadConfigObject(state),

  checkedItems: state.downloadConfig ? state.downloadConfig.checkedItems : {},
});

const mapActionsToProps = {
  generateDownloadConfigLink: downloadConfigActionMgr.callGenerateDownloadConfigLinkApi,
  clearSelectedFiles: () => dispatch(clearSelectedFiles()),

};
export default connect(mapStateToProps, mapActionsToProps)(withStyles(styles)(RequestConfigTable));
